import { CircularProgress } from "@mui/material";

export type LoadingProps = {
  loading: boolean;
};
export const Loading = ({ loading }: LoadingProps) =>
  loading ? <CircularProgress color="inherit" size={20} /> : null;
